import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import { EmailCatalogLibrary, EmailCatalogPreview } from '../molecules/emails/emails.types';

@Injectable({
  providedIn: 'root',
})
export class AdminBrandingEmailsService {
  private readonly http = inject(HttpClient);
  private readonly api = environment.shout_api.url;

  getEmailCatalog(): Observable<EmailCatalogLibrary> {
    return this.http.get<EmailCatalogLibrary>(`${this.api}/branding/emails`);
  }

  getEmailPreview(id: string): Observable<EmailCatalogPreview> {
    return this.http.get<EmailCatalogPreview>(`${this.api}/branding/emails/${id}/preview`);
  }
}
